import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

import * as styles from './Video.module.css';

const Video = ({ children }: { children: React.ReactNode }) => {
	const { variant } = useContext(ThemeContext);
	return <div className={cx(styles[variant], styles.video)}>{children}</div>;
};

const VideoScreen = ({
	src,
	title,
	poster,
	runtime,
	preview = false,
	mainScreen,
	setMainScreen,
}: {
	src?: string;
	title?: string;
	poster?: string;
	runtime?: string;
	preview?: boolean;
	mainScreen?: {
		src: string;
		poster: string;
		runtime: string;
		title: string;
	};
	setMainScreen?: any;
}) => {
	const [showPoster, setShowPoster] = useState(true);

	useEffect(() => {
		setShowPoster(true);
	}, [mainScreen]);

	return (
		<div className={cx(styles.bounds, { [styles.preview]: preview })}>
			{!preview ? (
				<ReactPlayer
					url={mainScreen?.src ? mainScreen.src : src}
					light={
						showPoster
							? mainScreen?.poster
								? mainScreen.poster
								: poster
								? poster
								: true
							: false
					}
					className={styles.screen}
					width="100%"
					height="100%"
					playIcon={<></>}
					playing={true}
					controls={true}
					onClickPreview={() => setShowPoster(false)}
					onEnded={() => setShowPoster(true)}
				/>
			) : (
				<button
					className={styles.button}
					onClick={() =>
						setMainScreen
							? setMainScreen({
									src: src,
									poster: poster,
									title: title,
									runtime: runtime,
							  })
							: null
					}
				>
					<figure className={styles.image}>
						<img src={poster} alt={title} />
					</figure>
				</button>
			)}

			{showPoster && (
				<div className={styles.poster}>
					{!preview && (
						<div className={styles.playIcon}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 320">
								<path d="M0 0v320l256-160L0 0Z" />
							</svg>
						</div>
					)}

					<div className={styles.meta}>
						{(mainScreen?.runtime || runtime) && (
							<div className={styles.runtime}>
								<p>{mainScreen?.runtime ? mainScreen.runtime : runtime}</p>
							</div>
						)}
						{(mainScreen?.title || title) && (
							<p className={styles.title}>
								{mainScreen?.title ? mainScreen.title : title}
							</p>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

const VideoAdditional = ({
	children,
	align,
}: {
	children: React.ReactNode[];
	align?: string;
}) => {
	return (
		<div className={cx(styles.additional, styles[align])}>
			<p className={styles.heading}>More videos from Tracsis</p>
			<div className={styles.track}>
				{children && children.length > 1
					? children.map((child) => child)
					: children}
			</div>
		</div>
	);
};

Video.Screen = VideoScreen;
Video.Additional = VideoAdditional;

export default Video;
